/**
 * @flow
 * @relayHash c30d6523139c123a7c5447c3214701a6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CSVImportEntity = "CUSTOMER" | "ITEM" | "ORDER" | "VENDOR";
export type CSVImportStatus = "COMPLETED" | "FAILED" | "IMPORTING" | "MAPPING" | "UPLOADING" | "VALIDATING";
export type UploadCSVImportInput = {|
  entityType: CSVImportEntity
|};
export type UploadCSVImportMutationVariables = {|
  input: UploadCSVImportInput
|};
export type UploadCSVImportMutationResponse = {|
  +uploadCSVImport: {|
    +csvImport: {|
      +csvImportId: string,
      +entityType: CSVImportEntity,
      +fileName: string,
      +status: CSVImportStatus,
      +headers: ?any,
      +previewRows: ?any,
      +totalRows: ?number,
      +columnMapping: ?any,
    |}
  |}
|};
export type UploadCSVImportMutation = {|
  variables: UploadCSVImportMutationVariables,
  response: UploadCSVImportMutationResponse,
|};
*/


/*
mutation UploadCSVImportMutation(
  $input: UploadCSVImportInput!
) {
  uploadCSVImport(input: $input) {
    csvImport {
      csvImportId
      entityType
      fileName
      status
      headers
      previewRows
      totalRows
      columnMapping
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UploadCSVImportInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "uploadCSVImport",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UploadCSVImportPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "csvImport",
        "storageKey": null,
        "args": null,
        "concreteType": "CSVImport",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "csvImportId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "entityType",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fileName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "headers",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "previewRows",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "totalRows",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "columnMapping",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UploadCSVImportMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UploadCSVImportMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UploadCSVImportMutation",
    "id": null,
    "text": "mutation UploadCSVImportMutation(\n  $input: UploadCSVImportInput!\n) {\n  uploadCSVImport(input: $input) {\n    csvImport {\n      csvImportId\n      entityType\n      fileName\n      status\n      headers\n      previewRows\n      totalRows\n      columnMapping\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7735d5d8f387da6773dea163bdbe3694';
module.exports = node;
